module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"hi":"Вітаю 👋","text1":"Я ваша помічниця CASES!","text2":"Як я можу вам допомогти?","generalSupport":"Щодо платформи CASES","learningSupport":"Щодо навчання та курсів"},"en":{"hi":"Hello 👋","text1":"I am your CASES assistant!","text2":"How can I help you?","generalSupport":"About the CASES platform","learningSupport":"About learning and courses"}}')
  delete Component.options._Ctor
}
